import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const SERVICES = [
  {
    title: "Revenue Leak Audit",
    desc: "A focused review of your listing to surface the 3–5 things quietly costing you bookings (and money).",
  },
  {
    title: "Strategy Intensive",
    desc: "A deep-dive plan customized to your property — positioning, pricing, guest experience, and systems.",
  },
  {
    title: "Monthly Advisory",
    desc: "Ongoing strategic guidance and accountability to help your business grow with clarity and confidence.",
  },
];

export default function Services() {
  return (
    <section data-testid="home-services" className="pt-14 lg:pt-16 pb-28 lg:pb-36 bg-ivory">
      <div className="container-editorial">
        <Reveal>
          <div className="max-w-3xl mb-20 lg:mb-24">
            <p className="overline mb-6">How I Help</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-navy leading-[1.08]">
              Strategic support for{" "}
              <em className="font-serif italic text-sage">every stage</em> of your business.
            </h2>
            <p className="font-sans text-base md:text-lg text-charcoal/70 mt-7 leading-[1.75] max-w-2xl">
              From quick clarity to long-term advisory, choose the support that fits where you are —
              and where you're going.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-warmGray/20">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 110}>
              <div
                data-testid={`service-card-${i}`}
                className="group bg-ivory hover:bg-cream p-10 lg:p-14 transition-colors duration-500 flex flex-col h-full"
              >
                <span className="block w-10 h-px bg-gold mb-10" />
                <h3 className="font-serif text-[1.7rem] lg:text-[1.95rem] text-navy leading-[1.15] mb-7">
                  {s.title}
                </h3>
                <p className="font-sans text-[15px] text-charcoal/75 leading-[1.78] mb-12 flex-1">
                  {s.desc}
                </p>
                <Link
                  to="/services"
                  data-testid={`service-learn-more-${i}`}
                  className="editorial-link inline-flex items-center self-start"
                >
                  Learn More
                  <ArrowRight className="w-3.5 h-3.5 ml-1.5 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
